import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ImpersonationService } from './impersonation.service';

/**
 * Persistent banner shown across the whole app while a SuperAdmin is viewing a
 * society. Provides the "Exit" action to return to the platform context.
 */
@Component({
    selector: 'impersonation-banner',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, AsyncPipe, MatButtonModule, MatIconModule],
    template: `
        <div
            *ngIf="impersonation.state$ | async as state"
            [class.hidden]="!state.active"
        >
            <div
                *ngIf="state.active"
                class="flex items-center justify-center gap-3 px-4 py-2 bg-amber-600 text-white text-sm font-medium"
            >
                <mat-icon
                    class="icon-size-5 text-white"
                    svgIcon="heroicons_solid:eye"
                ></mat-icon>
                <span>
                    You are viewing
                    <strong>{{ state.societyName || 'a society' }}</strong>
                    as a Super Admin.
                </span>
                <button
                    mat-stroked-button
                    class="ml-2 text-white border-white"
                    (click)="exit()"
                >
                    Exit
                </button>
            </div>
        </div>
    `,
})
export class ImpersonationBannerComponent {
    impersonation = inject(ImpersonationService);

    exit(): void {
        this.impersonation.exit();
    }
}
